import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MissionSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';

import Button from "../../common_components/Button";
import Timeline from "./Timeline";
import ScheduleModal from "./ScheduleModal";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import MissionEventAPI from "../../../api/api_calls/MissionEventAPI";

function MissionSchedule({ mission, userMissionState, refreshMissionStatus }) {
    const navigate = useNavigate();
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [availabilities, setAvailabilities] = useState([]);
    const [missionEvent, setMissionEvent] = useState(null);
    const [lookAheadDays, setLookAheadDays] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [timeZone, setTimeZone] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showScheduleButton, setShowScheduleButton] = useState(false);

    // Set button to full width if the screen is < 840px
    const fullWidthButton = window.innerWidth < 840;



    // Fetch the availabilities for this mission. 
    useEffect(() => {
        async function fetchAvailabilities() {
            const response = await MissionEventAPI.fetch_availabilities(mission.id);

            if (response.success) {
                setAvailabilities(response.appointment_list);
                setShowScheduleButton(response.appointment_list.days.length > 0);
                setMissionEvent(response.mission_event);
                setLookAheadDays(response.look_ahead_days);
                setStartDate(response.appointment_list.start_date);
                setEndDate(response.appointment_list.end_date);
                setTimeZone(response.user_timezone);
            }
            setLoading(false);
        }
        fetchAvailabilities();
    }, []);



    return (
        <>
            <MissionSubCard>
                <Timeline mission={mission} userMissionState={userMissionState} />
                <MissionSubCardHorizontalDivider />
                {loading ? <CenteredLoadingIcon /> :
                    (showScheduleButton ?
                        <Button size="medium" color="primary" fullWidth={fullWidthButton} onClick={() => setShowScheduleModal(true)}>Schedule my interview</Button>
                        :
                        <div className="mission-schedule-no-availabilities-text">There are no open interview slots for this mission. Please check back later.</div>
                    )
                }
            </MissionSubCard>
            {!loading && <ScheduleModal
                isOpen={showScheduleModal}
                missionId={mission.id}
                toggleModal={() => setShowScheduleModal(!showScheduleModal)}
                availabilities={availabilities}
                lookAheadDays={lookAheadDays}
                startDate={startDate}
                endDate={endDate}
                timeZone={timeZone}
                refreshMissionStatus={refreshMissionStatus}
            />}
        </>
    )
}

export default MissionSchedule;